import { render, staticRenderFns } from "./KifuSearch.vue?vue&type=template&id=07346644&scoped=true&"
import script from "./KifuSearch.vue?vue&type=script&lang=js&"
export * from "./KifuSearch.vue?vue&type=script&lang=js&"
import style0 from "./KifuSearch.vue?vue&type=style&index=0&id=07346644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07346644",
  null
  
)

export default component.exports